<template>

  <div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
      <h2>
        <a href="#/after-sales">{{$t('afterSales.title')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{ $t('afterSales.upload_document.title') }}
      </h2>

      <p>{{ $t('afterSales.upload_document.description') }}</p>

      <div class="irinox-form after-sales" >
        <form @submit.prevent="onSubmit(!v$.form.$invalid)" class="">

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-4">
                  <label for="title" >{{ $t('afterSales.upload_document.doc_title') }}</label>
                  <InputText id="title" v-model="form.title" :placeholder="$t('afterSales.upload_document.doc_title_ph')" 
                    :class="{'p-invalid':v$.form.title.$invalid && submitted}"/>
              </div>
          </div>

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-4">
                  <label for="lang">{{ $t('afterSales.upload_document.lang') }}</label>
                  <Dropdown id="lang"
                      v-model="form.language"
                      :options="languages"
                      optionLabel="label"
                      optionValue="value"
                      :placeholder="$t('afterSales.upload_document.lang_ph')" 
                      :class="{'p-invalid':v$.form.language.$invalid && submitted}">
                      <template #value="slotProps">
                          <div v-if="slotProps.value" class="p-d-flex p-ai-center">
                              <img v-if="slotProps.value!='MULTI'" :alt="slotProps.value.label" src="assets/demo/flags/flag_placeholder.png" :class="`p-mr-2 flag flag-${langs[slotProps.value].flag}`" style="width: 18px" />
                              <div>{{ langs[slotProps.value].name }}</div>
                          </div>
                          <span v-else>
                              {{ slotProps.placeholder }}
                          </span>
                      </template>
                      <template #option="slotProps">
                          <div class="p-d-flex p-ai-center">
                              <img v-if="slotProps.option.value!='MULTI'" :alt="slotProps.option.label" src="assets/demo/flags/flag_placeholder.png" :class="`p-mr-2 flag flag-${langs[slotProps.option.value].flag}`" style="width: 18px" />
                              <div>{{ slotProps.option.label }}</div>
                          </div>
                      </template>
                  </Dropdown>
              </div>
              <div class="p-field p-col-12 p-md-4">
                  <label for="category">{{ $t('afterSales.upload_document.category') }}</label>
                  <Dropdown id="category"
                      v-model="form.category"
                      :options="categories"
                      filter 
                      optionLabel="label"
                      optionValue="value"
                      :placeholder="$t('afterSales.upload_document.category_ph')" 
                      :class="{'p-invalid':v$.form.category.$invalid && submitted}" />
              </div>
              <div class="p-field p-col-12 p-md-4">
                  <label for="domain">{{ $t('afterSales.upload_document.domain') }}</label>
                  <Dropdown id="domain"
                      v-model="form.domain"
                      :options="domains"
                      optionLabel="label"
                      optionValue="value"
                      :placeholder="$t('afterSales.upload_document.domain_ph')" 
                      :class="{'p-invalid':v$.form.domain.$invalid && submitted}" />
              </div>
          </div>

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                  <label>{{ $t('afterSales.upload_document.access_type') }}</label>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.access" class="p-mr-2" inputId="access1" name="access" value="PUBLIC" 
                        :class="{'p-invalid':v$.form.access.$invalid && submitted}" />
                      <p v-html="$t('afterSales.upload_document.access_type_ALL')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.access" class="p-mr-2" inputId="access2" name="access" value="RESTRICTED" 
                        :class="{'p-invalid':v$.form.access.$invalid && submitted}" />
                      <p v-html="$t('afterSales.upload_document.access_type_RES')"></p>
                  </div>
                  <p class="light-text">{{ $t('afterSales.upload_document.access_type_description') }}</p>
              </div>
          </div>

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                  <label>{{ $t('afterSales.upload_document.distribution') }}</label>
                  <div class="p-field-checkbox p-my-1">
                    <Checkbox v-model="form.distributions" class="p-mr-2" :aria-label="$t('afterSales.upload_document.distribution_machine_dashboard')" name="distributions" value="machine_dashboard"
                        :class="{'p-invalid':v$.form.distributions.$invalid && submitted}"/>
                    <p v-html="$t('afterSales.upload_document.distribution_machine_dashboard')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                    <Checkbox v-model="form.distributions" class="p-mr-2" :aria-label="$t('afterSales.upload_document.distribution_generic_section')" name="distributions" value="generic_section"
                        :class="{'p-invalid':v$.form.distributions.$invalid && submitted}"/>
                    <p v-html="$t('afterSales.upload_document.distribution_generic_section')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                    <Checkbox v-model="form.distributions" class="p-mr-2" :aria-label="$t('afterSales.upload_document.distribution_external_platform')" name="distributions" value="external_platform"
                        :class="{'p-invalid':v$.form.distributions.$invalid && submitted}"/>
                    <p v-html="$t('afterSales.upload_document.distribution_external_platform')"></p>
                  </div>
              </div>
          </div>

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                <label>{{ $t('afterSales.upload_document.machines_association') }}</label>
                <div v-if="form.docTreeIds.length>0"  class="p-my-3 p-d-flex p-ai-center p-flex-wrap selected-machines">
                  <div v-for="id in form.docTreeIds" :key="id" class="selected-machine p-grid-nogutter p-ai-center">
                    <div class="p-col-fixed" style="width: 100px; overflow: hidden;">
                      <img :src="$config.afterSalesAssets('models') + findLastLevel(id).key + '.svg'" :alt="'MODEL'" />
                    </div>
                    <div class="p-col">
                      <span>{{ findLastLevel(id).label }}</span>
                    </div>
                    <div class="p-col-fixed">
                      <i class="icon-trash" @click="removeMachine(id)"></i>
                    </div>
                  </div>
                </div>
                <div class="p-my-1">
                  <Button :disabled="!form.domain" class="p-button-secondary small-button" :label="$t('afterSales.upload_document.machines_association_button')" :severity="v$.form.docTreeIds.$invalid && submitted ? 'danger' : ''"
                    @click="dialog.selectModel = true"/>
                </div>
              </div>
          </div>

          <div v-if="previousVersions?.length>0" class="existing-document">
            <i class="icon-alert"></i>
            <span>{{ $t('afterSales.upload_document.existing_document') }}</span>
          </div>

          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                  <label>{{ $t('afterSales.upload_document.type') }}</label>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.type" class="p-mr-2" inputId="type1" name="docType" value="FILE" />
                      <p v-html="$t('afterSales.upload_document.type_file')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.type" class="p-mr-2" inputId="type2" name="docType" value="LINK" />
                      <p v-html="$t('afterSales.upload_document.type_video')"></p>
                  </div>
              </div>
          </div>

          <div v-if="form.type === 'FILE'" class="p-fluid p-formgrid p-grid">
              <div :class="['p-field p-col-12 p-xl-6', {'p-invalid':v$.form.files.$invalid && submitted}]" >
                  <label>{{ $t('afterSales.upload_document.upload_file') }}</label>

                  <FileUpload
                    ref="uploader"
                    mode="advanced"
                    :multiple="false"
                    :customUpload="true"
                    :showUploadButton="false"
                    :showCancelButton="false"
                    :maxFileSize="1000 * 1000 * 1000"
                    :chooseLabel="$t('afterSales.upload_document.upload_file_choose')"
                    @select="onFileSelect"
                    @remove="onFileRemove"
                    @clear="onClear"
                    :disabled="form.files.length > 0"
                  >

                    <template #empty>
                      <p>{{ $t('afterSales.upload_document.upload_file_drag_and_drop') }}</p>
                    </template>
                  </FileUpload> 

              </div>
          </div>

          <div v-if="form.type === 'LINK'" class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-xl-6">
                  <label for="link" >{{ $t('afterSales.upload_document.link') }}</label>
                  <InputText id="link" v-model="form.link" :placeholder="$t('afterSales.upload_document.link_ph')"
                    :class="{'p-invalid':v$.form.link.$invalid && submitted}" />
                </div>
                <div v-if="youtubePreview" class="p-field p-col-12">
                  <label>{{ $t('afterSales.upload_document.link_preview') }}</label>
                  <div>
                    <iframe :src="youtubePreview" title="YouTube video player" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  </div>
                </div>
          </div>

          <div class="">
              <label>{{ $t('afterSales.upload_document.version') }}</label>

              <div v-if="!previousVersions || previousVersions.length === 0">{{ $t('afterSales.upload_document.version_new') }}</div>

              <div v-else class="p-grid">
                <div  class="p-col-12">

                  <div class="previous-version p-grid" v-for="vv in previousVersions" :key="vv.documentId" @click="openDocument(vv)">
                    <div class="p-col-fixed" style="width: 220px">
                      <div><b>{{ $functions.timeAgo(vv.insertDate) }}</b></div>
                      <div>{{ is24hour ? $d(new Date(vv.insertDate), "long") : $d(new Date(vv.insertDate), 'long12') }}</div>
                    </div>
                    <div class="p-col-fixed" style="width: 70px">
                      <i v-if="vv.type === 'FILE'" :class="['pi', $functions.documentIcon(vv.externalRef)]" />
                      <i v-else :class="['pi', $functions.linkIcon(vv.externalRef)]" />
                    </div>
                    <div class="p-col" style="text-wrap: wrap;">
                      {{ vv.type === 'FILE' ? vv.externalRef.split('/').pop().split('?')[0]?.replace(/%2F/g,'/') : vv.externalRef }}
                    </div>
                    
                    
                    <div  class="p-col" style=""><b>HASH:</b> {{ vv.hash }}</div>
                  </div>
                </div>
              </div>

          </div>

          <div class="p-fluid p-formgrid p-grid p-mt-4">
              <div class="p-d-flex p-col-12 p-xl-6">
                <Button type="submit" :label="previousVersions?.length>0 ? $t('afterSales.upload_document.update_document') : $t('afterSales.upload_document.save_document')" class="p-mr-2" />
                <Button type="button" :label="$t('afterSales.upload_document.reset_form')" class="p-button-secondary" @click="resetForm" />
              </div>
          </div>

          <!-- <div class="red">
            <div>TITLE: {{ v$.form.title.$invalid ? 'Invalid' : '' }}</div>
            <div>CATEGORY: {{ v$.form.category.$invalid ? 'Invalid' : '' }}</div>
            <div>LANGUAGE: {{ v$.form.language.$invalid ? 'Invalid' : '' }}</div>
            <div>DOMAIN: {{ v$.form.domain.$invalid ? 'Invalid' : '' }}</div>
            <div>ACCESS: {{ v$.form.access.$invalid ? 'Invalid' : '' }}</div>
            <div>distributions: {{ v$.form.distributions.$invalid ? 'Invalid' : '' }}</div>
            <div>DOCTREEIDS: {{ v$.form.docTreeIds.$invalid ? 'Invalid' : '' }}</div>
            <div>FILES: {{ v$.form.files.$invalid ? 'Invalid' : '' }}</div>
            <div>LINK: {{ v$.form.link.$invalid ? 'Invalid' : '' }}</div>
            <div>-- FORM: {{ !v$.form.$invalid ? 'Valid' : '' }}</div>
          </div> -->


        </form>
      </div>

    </div>
  </div>

  <Toast />

  <DocTreeSelect :visible="dialog.selectModel" :docTreeRaw="docTreeRaw" :docTreeIds="form.docTreeIds" :domain="form.domain"
    @update:visible="dialog.selectModel = $event" @update:docTreeIds="updateDocTreeIds"/>

  
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.dl_success" 
    mode="success" 
    :message="$t('afterSales.download_doc_success')"
    :life="3000" 
    @update:visible="dialog.dl_success = $event" />
  <IrinoxDialogDark :visible="dialog.up_success" 
    mode="success" 
    :message="$t('afterSales.upload_doc_success')"
    :life="3000" 
    @update:visible="dialog.up_success = $event" />


</template>

<script>
// import { required, email, sameAs, minLength, maxLength, numeric, minValue, maxValue, requiredIf } from "@vuelidate/validators";
import { required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { mapGetters } from 'vuex';
import DocTreeSelect from './DocTreeSelect.vue';
import AfterSalesService from '../../service/AfterSalesService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';

export default {
  components: { 
    DocTreeSelect,
    IrinoxDialogDark
  },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      form: { 
        title: null, 
        category: null,
        language: null,
        domain: null, 
        access: null,
        distributions: [],
        docTreeIds: [],
        type: 'FILE',
        files: [],
        link: null,
      },
      categories: [],
      langs: this.$functions.documentLanguages(),
      domains: [
        { label: this.$t('afterSales.domain_STANDARD'), value: 'STANDARD' },
        { label: this.$t('afterSales.domain_NORTH_AMERICA'), value: 'NORTH AMERICA' },
        // { label: this.$t('afterSales.domain_FMI_JAPAN'), value: 'FMI JAPAN' },
      ],
      submitted: false,
      previousVersions: [],
      dialog: {
        selectModel: false,
        error: false,
        up_success: false,
        dl_success: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      docTreeRaw: 'afterSales/docTreeRaw',
      is24hour: 'userdata/is24hour',
    }),
    languages() {
      let temp = [];
      for(let l in this.langs) {
        temp.push({ label: this.langs[l].name, value: l });
      }
      return temp;
    },
    youtubePreview() {
      if(this.form.link && this.form.link.includes('youtube.com')) {
        const url = new URL(this.form.link);
        const videoId = url.searchParams.get('v');
        if(videoId) {
          return `https://www.youtube.com/embed/${videoId}`;
        }
      }
      return null;
    },
    isKeySelected() {
      return this.form.title && this.form.category && this.form.language && this.form.domain && this.form.docTreeIds.length>0;
    },
  },
  validations() {
      return {
          form: {
            title: {
                required
            },
            category: {
                required
            },
            language: {
                required
            },
            domain: {
                required
            },
            access: {
                required
            },
            distributions: {
                required,
            },
            docTreeIds: {
                required: requiredIf(function() {
                  return this.form.domain!=null
                }),
            },
            files: {
                required: requiredIf(function() {
                  return this.form.type==='FILE'
                }),
            },
            link: {
                required: requiredIf(function() {
                  return this.form.type==='LINK'
                }),
            },
          }
      };
  },
  watch: {
    'form.domain': 'changeDomain',
    'form.title': 'checkKeySelection',
    'form.language': 'checkKeySelection',
    'form.category': 'checkKeySelection',
    'form.docTreeIds': 'checkKeySelection',
  },
  created() {
    this.afterSalesService = new AfterSalesService();
  },
  mounted() { 
    if(this.docTreeRaw.length===0) {
      this.$router.push('/after-sales');
    }
    this.getCategories();
  },
  methods: {
    changeDomain() { 
      this.form.docTreeIds = [] 
    },
    getCategories() {
      this.categories = [];
      this.afterSalesService.getCategories(this.personaltoken)
        .then((data) => {
          if(data.code==="200" && data.body) {
            data.body.forEach(cat => {
              this.categories.push({ label: this.$t('afterSales.category.'+cat), value: cat });
            });
            this.categories.sort((a,b) => (a.label>b.label) ? 1 : ((b.label>a.label) ? -1 : 0));
          } else {
            console.error("ERROR "+JSON.stringify(data));
          }
        })
        .catch(error => {
          console.error("EXCEPTION "+error);
        });
    },
    checkKeySelection() {
      if(this.isKeySelected) {
        this.afterSalesService.getPreviousVersions(this.personaltoken, this.form.domain, this.form.category, this.form.language, this.form.title, this.form.docTreeIds)
          .then((data) => {
            if(data.code=="200") {
              this.previousVersions = data.body.sort((a,b) => (a.version<b.version) ? 1 : ((b.version<a.version) ? -1 : 0));
            } else {
              console.error("ERROR " + JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION " + error);
            this.dialog.error = true;
          });
      }
    },
    updateDocTreeIds(ids) {
      this.form.docTreeIds = ids;
    },
    getDocTreeById(id) {
      return this.docTreeRaw.find(node => node.docTreeId === id);
    },
    findLastLevel(id) {
      let docTree = this.getDocTreeById(id);
      if(docTree) {
        for(let i=5; i>=1; i--) {
          if(docTree['level'+i]) {
            return { key: docTree['level'+i], label: (docTree['level'+(i-1)+'Translation'] || docTree['level'+(i-1)]) + ' - ' + (docTree['level'+i+'Translation'] || docTree['level'+i]) };
          }
        }
      }
    },
    removeMachine(id) {
      this.form.docTreeIds = this.form.docTreeIds.filter(docTreeId => docTreeId !== id);
    },
    onFileSelect(e) {
      this.form.files = [...e.files]
    },
    onFileRemove(e) { 
      this.form.files = this.form.files.filter(f => f !== e.file) 
    },
    onClear() { 
      this.form.files = [] 
    },
    async onSubmit(isFormValid) {
      this.submitted = true;
      if (!isFormValid) {
        return;
      }
      let data = {
        title: this.form.title, 
        category: this.form.category,
        language: this.form.language,
        domain: this.form.domain, 
        access: this.form.access,
        distributions: this.form.distributions,
        docTreeIds: this.form.docTreeIds,
        type: this.form.type,
        link: this.form.type==='LINK' ? this.form.link : null,
      }
      this.afterSalesService.uploadDocument(this.personaltoken, data, this.form.type==='FILE' ? this.form.files[0] : null)
        .then((data) => {
          if(data.code==="200") {
            this.dialog.up_success = true;
            this.resetFormPartially();
          } else {
            console.error("ERROR "+JSON.stringify(data));
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("EXCEPTION "+error);
          this.dialog.error = true;
        });
    },
    resetForm() {
      this.form = { 
        title: null, 
        category: null,
        language: null,
        domain: null, 
        access: null,
        distributions: [],
        docTreeIds: [],
        type: 'FILE',
        files: [],
        link: null,
      }
      this.submitted = false;
      this.previousVersions = [];
      this.$refs.uploader?.clear()
    },
    resetFormPartially() {
      this.form.title = null;
      this.form.files = [];
      this.form.link = null;
      this.submitted = false;
      this.previousVersions = [];
      this.$refs.uploader?.clear()
    },
    openDocument(doc) {
      // Logic to open the document
      if(doc.type === 'FILE') {
        this.download(doc);
      } else if(doc.type === 'LINK' && doc.externalRef) {
        window.open(doc.externalRef, '_blank');
      }
    },
    download(doc) {
        this.afterSalesService.downloadDocument(doc.externalRef)
          .then((res) => {
            let contentType = res.headers["content-type"];
            if(contentType !== 'application/json') {
              let filename = doc.title;
              try {
                const url = new URL(doc.externalRef);
                const decodedPath = decodeURIComponent(url.pathname);
                const parts = decodedPath.split('/');
                const last = parts[parts.length - 1];
                if (last) filename = last;
              } catch (e) { /* keep doc.title as fallback */ }
              this.dialog.success = true;
              let blob=new Blob([res.data], {type: contentType});
              let link=document.createElement('a');
              link.href=window.URL.createObjectURL(blob);
              link.download=filename;
              link.click();
            } else {
              console.error("EXCEPTION "+JSON.stringify(res));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      }
  }
}
</script>